import { first, last, startCase } from 'lodash';

export const getFirstNameLastInitial = (fullName: string): string => {
  if (!fullName) {
    return '';
  }
  const splitNames = fullName.split(' ');

  return `${first(splitNames)} ${last(splitNames)?.charAt(0).toUpperCase()}.`;
};

export const getFullNameFirstLettersUpper = (fullName: string): string => {
  if (!fullName) {
    return '';
  }

  return startCase(fullName);
};
